import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-vrt-new-version-dialog',
  standalone: false,
  template: `
    <h2 mat-dialog-title>Create New Version</h2>
    <mat-dialog-content>
      <p>This will create a new editable version of <strong>{{ data.mapName }}</strong>.</p>
      <p style="color: #666; font-size: 13px;">The original finalised map will remain unchanged and accessible.</p>
    </mat-dialog-content>
    <mat-dialog-actions style="display: flex; justify-content: space-between;">
      <button mat-button mat-dialog-close>Cancel</button>
      <button mat-flat-button color="primary" (click)="confirm()">Create New Version</button>
    </mat-dialog-actions>
  `
})
export class VrtNewVersionDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<VrtNewVersionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { mapName: string }
  ) {}

  confirm() {
    this.dialogRef.close({ confirmed: true });
  }
}
